import Upsertable from '@/models/Upsertable'
import { useAssessmentStore } from '@/stores/assessmentStore'
import { useModelName } from '@/composables/useModelName.js'
import { ModelRegistry } from '@/models/modelRegistry.js'

export default class Assessment extends Upsertable {
  constructor() {
    super()
    this.scored_at = Date.now()
  }

  static store() {
    return useAssessmentStore()
  }

  store() {
    return Assessment.store()
  }

  static all() {
    return Assessment.store().getAll
  }

  static find(uuid) {
    const obj = Assessment.store().find(uuid)
    let assessment = new Assessment()
    return Object.assign(assessment, obj)
  }
}

useModelName(Assessment, "Assessment")
ModelRegistry.register(Assessment, "Assessment")